import React, { Fragment, useContext, useEffect, useState } from 'react';
import HeaderComponent from '../../components/HeaderComponent';
import stylebtn from '../../styles/btn.module.scss';
import TitleH2Component from '../../components/TitleH2Component';
import TitleH4Component from '../../components/TitleH4Component';
import ParrafoComponent from '../../components/ParrafoComponent';
import styleBtn from '../../styles/btn.module.scss';
import { Icon } from '@iconify/react/dist/iconify.js';
import ModalGeneralComponent from '../../components/ModalGeneralComponent';
import InputComponent from '../../components/InputComponent';
import styleform from '../../styles/form.module.scss';
import { UserContext } from '../../context/UserContext';
import { BuscarCliente, PostActualizarventa, PostCliente } from '../../api/ApiVenta';
import { BuscarFactura, deleteDetalleVenta, Editarfactura, EliminarFactura, obtenerDetalleFactura, PostAbonoFactura, Postfactura, PostfacturaDetalle } from '../../api/Factura';
import { PostPersona } from '../../api/Empleado';
import AlertComponent from '../../components/AlertComponent';
import LoaderComponent from '../../components/LoaderComponent';
import { Link, useNavigate, useParams } from 'react-router-dom';
import MoneyInputComponent from '../../components/MoneyInputComponent';
import { useAuth } from '../../context/AuthContext';
import SelectComponent from '../../components/SelectComponent';
import { getTransporte } from '../../api/transporte';
import stylegenral from "../../styles/general.module.scss";
import { abrirPdfVentas } from '../../api/Pdf';
const CarritoPage = () => {
	const [showEliminar, setShowEliminar] = useState(false);
	const [showEliminarBD, setShowEliminarBD] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const [showEditBD, setShowEditBD] = useState(false);
	const [showaddpendientes, setShowaddpendientes] = useState(false);
	const [showCliente, setShowCliente] = useState(false);
	const [compraExitosa, setCompraExitosa] = useState(false);
	const { carrito, setCarrito, setNumCarrito } = useContext(UserContext);
	const [currentCarrito, setCurrentCarrito] = useState([]);
	const [cantidadVenta, setCantidadVenta] = useState('');
	const [mensaje, setMensaje] = useState('');
	const [totalNeto, setTotalNeto] = useState(0);
	const [descuento, setDescuento] = useState(0);
	const [transporte, setTransporte] = useState(0);
	const [subTotal, setSubTotal] = useState(0);
	const [idCliente, setIdCliente] = useState('');
	const [fechaPago, setFechaPago] = useState(null);
	const [montonFinanciado, setMontonFinanciado] = useState(0)
	const [financiado, setFinanciado] = useState(0)
	const [currentPersona, setCurrentPersona] = useState([]);
	const [currentCliente, setCurrentCliente] = useState([]);
	const [control, setcontrol] = useState([]);
	const [numeroFactura, setNumeroFactura] = useState('');
	const [pendientePorentraga, setPendientePorentrega] = useState({});
	const [pendientevalor, setPendienteValor] = useState('');
	const [alert, setAlert] = useState(false);
	const [loading, setLoading] = useState(false);
	const [currentFD, setCurrentFD] = useState([]);
	const [idfactura, serIdfactura] = useState(null);
	const [totalAbonos, setTotalAbono] = useState(0);
	const [fechaActual, setFechaActual] = useState('');
	const [clienteVerificado, setClienteVerificado] = useState(false);
	const [IDTransporte, setIDTransporte] = useState('')
	const [dataTransporte, setDatTransporte] = useState([]);
	const [descripcionAbono, setDescripcionAbono] = useState("");
	const [currentProductos, serCurrentProductos] = useState([])
	const [currentProducto, setCurrentProducto] = useState([]);
	const [currentFactura, setCurrentFactura] = useState([]);
	const [transporteID, setTransporteID] = useState("")
	const { id } = useParams();
	  const navigate = useNavigate();
	const STORAGE_KEY = "productos_factura_existente";
	const { isAdmin, idUser, isSuper } = useAuth();
	const [formDataPersona, setFormDataPersona] = useState({
		cedula: '',
		nombre: '',
		apellido: '',
		direccion: '',
		celular: '',
	});

	const [formDataFactura, setFormDataFactura] = useState({
		quien_recibe: "",
		direccion_envio: "",
		nombre_conductor: "",
		celular_conductor: "",
	});


	// Manejar el cambio de valor en el input perndiente por entrega 
	const handleInputChangependienteporentrega = (e, itemId) => {
		setPendientePorentrega((prev) => ({
			...prev,
			[itemId]: e.target.value,
		}));
	};

	const handleInputChangeFactura = (event) => {
		const { name, value } = event.target;
		setFormDataFactura({
			...formDataFactura,
			[name]: value,
		});
	};

	//Metodo para capturar los valotes de la descripcion
	const handleChangeDescripcion = (event) => {
		setDescripcionAbono(event.target.value);
	};

	// Manejar el cambio en el input para el numero de factura 
	const handleInputChangeNumeroFactura = (event) => {
		setNumeroFactura(event.target.value);
	};

	// Manejar el cambio en el input para las fechas de pagos 
	const handleInputChangefechapago = (event) => {
		setFechaPago(event.target.value);
	};
	// Manejar el cambio en el input para el monton financiado
	const handleInputChangemontonfinanciado = (event) => {
		setMontonFinanciado(event.target.value);
	};

	// Manejar el cambio en el input
	const handleInputChangedescuento = (event) => {
		setDescuento(event.target.value);
	};

	// Manejar el cambio en el input
	const handleInputChangetransporte = (event) => {
		setTransporte(event.target.value);
	};

	// Manejar el cambio en el input
	const handleInputChangePersona = (event) => {
		const { name, value } = event.target;
		setFormDataPersona({
			...formDataPersona,
			[name]: value,
		});
	};
	const [checkboxes, setCheckboxes] = useState({
		isChecked: false,
		isCheckedDescuento: false,
		isCheckedpago: false,
		isCheckedPendiente: false,
		istransporte: false,
	});

	//const [data] = useState([...Array(1).keys()]);

	const handleCloseaddpendientes = () => setShowaddpendientes(false);
	// metodo para obtener el valor pendiente
	const obtnerpendiente = (item) => {
		setShowaddpendientes(true);
		setCurrentCarrito(item);
		setPendienteValor(pendientePorentraga[item.id] || 0)
	};

	const addPendientes = (id, updatevalor) => {
		if (pendientevalor < 0) {
			setMensaje(`la cantidad ingresada es incorrecta `)

		} else {
			const nuevoCarrito = carrito.map(item =>
				item.id === id ? { ...item, ...updatevalor } : item
			);
			setCarrito(nuevoCarrito);
			localStorage.setItem('carrito', JSON.stringify(nuevoCarrito));
			handleCloseaddpendientes();
			setAlert(true);
			setMensaje(`Se agragaron ${pendientevalor} pendientes por entregar`)
		}

		setTimeout(() => {
			setAlert(false);
			setMensaje('')
		}, 3000);
	}


	// Metodos para el popup de eliminar
	const handleCloseEliminar = () => {
		setShowEliminar(false);
		setShowEliminarBD(false)
	};
	const handleShowEliminar = (item) => {
		setShowEliminar(true)
		setCurrentCarrito(item)
	};


	// Metodos para el popup de eliminar
	const handleCloseEdit = () => {
		setShowEdit(false)
		setShowEditBD(false)
	};
	const handleShowEdit = (item) => {
		setCurrentCarrito(item)
		setShowEdit(true)
		setCantidadVenta(item?.cantidad)
	};

	// Metodos para el popup del cliente
	const handleClosecliente = () => {
		setShowCliente(false);
		setCompraExitosa(false);
		setClienteVerificado(false);
		setFormDataPersona({
			cedula: formDataPersona.cedula,
			nombre: '',
			apellido: '',
			direccion: '',
			celular: '',

		})
		if (compraExitosa) {
			window.location.href = "/home"
		}

	};

	// metodo que  captura la fecha actual

	const capturarFecha = () => {
		const hoy = new Date();
		const fechaFormateada = hoy.toISOString().split('T')[0]; // Formato YYYY-MM-DD
		setFechaActual(fechaFormateada);
	};


	const handleShowcliente = async () => {
		capturarFecha();
		if (checkboxes.isCheckedpago) {
			if (numeroFactura === '') {
				setMensaje('Debe agregar el numero de la factura')

			} else {
				const resF = await BuscarFactura(numeroFactura);

				const totalMontos = resF?.data?.Abonos?.reduce((total, item) => {
					return total + Number(item.monto);
				}, 0);

				setTotalAbono(totalMontos);
				if (resF?.success) {
					if (resF?.data?.estado === 0) {
						setMensaje('La factura se encuntra cerrada')
					} else {

						const productosInsuficientes = currentProductos.some(
							item => item.cantidadTotal < item?.cantidad
						);


						if (productosInsuficientes) {
							setMensaje('Existe por lo menos un producto con cantidad insufiencte en su lista')

						} else {
							setShowCliente(true);
							setFormDataPersona({
								cedula: resF?.data?.Cliente?.Persona?.cedula,
								nombre: resF?.data?.Cliente?.Persona?.nombre,
								apellido: resF?.data?.Cliente?.Persona?.apellido,
								direccion: resF?.data?.Cliente?.Persona?.direccion,
								celular: resF?.data?.Cliente?.Persona?.celular
							})


							// Crear el nuevo array fusionado
							const productosDespacho = currentProductos.reduce((acc, productoCarrito) => {
								// Busca en la factura productos que coincidan en clase, tipo, y dimensión
								const productoFactura = resF?.data?.DetalleFacturas.find(productoFact =>
									productoFact?.Producto?.Clase?.name === productoCarrito.clase &&
									productoFact?.Producto?.Tipo?.name === productoCarrito.tipo &&
									productoFact?.Producto?.dimension === productoCarrito.dimension &&
									productoFact?.pendientePorEntregar > 0 &&
									productoCarrito?.cantidadTotal > 0 &&
									productoCarrito?.cantidadTotal >= Number(productoCarrito.cantidad) &&
									productoCarrito?.cantidad > 0
								);

								// Si se encuentra un producto que coincide
								if (productoFactura) {
									// Crea un nuevo objeto con los datos combinados
									const productoFusionado = {
										idDetalleFactura: productoFactura.id,
										...productoCarrito

									};

									// Añadir al array acumulador
									acc.push(productoFusionado);
								}

								return acc;
							}, []);
							setCurrentFD(productosDespacho);

						}

					}
				} else {

					setMensaje(resF.message)
				}
			}
		} else {
			if (checkboxes.isChecked && (montonFinanciado == 0 || fechaPago == null || fechaPago == '' || fechaPago < fechaActual)) {

				setMensaje('Debe asignar un monton a financiar y una fecha limite de pago valida')

			} else {
				setShowCliente(true);
			}

		}
		setTimeout(() => {
			setMensaje('')
		}, 5000);
	};

	// este es el metodo para sacar el valor del check
	const handleCheckboxChange = (event) => {
		const { id, checked } = event.target;
		setCheckboxes((prevCheckboxes) => ({
			...prevCheckboxes,
			[id]: checked,
		}));

		// ✅ Limpiar campos relacionados cuando se desmarca "istransporte"
		if (id === "istransporte" && !checked) {
			setTransporte("")
		}

		// ✅ Limpiar campos relacionados cuando se desmarca "isCheckedDescuento"
		if (id === "isCheckedDescuento" && !checked) {
			setDescuento("");
		}

		// ✅ Limpiar campos relacionados cuando se desmarca "is"
		if (id === "isChecked" && !checked) {
			setMontonFinanciado("");
			setFechaPago(null);
			setDescripcionAbono("")
		}
	};

	// metodo para eliminar del carrito de compra 
	const eliminarItem = () => {
		const nuevoCarrito = carrito.filter(item => item.id !== currentCarrito?.id);
		setCarrito(nuevoCarrito);
		setNumCarrito(nuevoCarrito.length);
		localStorage.setItem('carrito', JSON.stringify(nuevoCarrito));
		handleCloseEliminar();
	};

	// metodo para editar del carrito de compra 
	const editarItem = (id, updatedItem) => {
		if (updatedItem.cantidad > currentCarrito?.cantidadTotal) {
			setMensaje(`Cantidad es mayor a la disponibles, disponible solo ${currentCarrito?.cantidadTotal} unidades por favor consultar otro puesto`)

		} else if (cantidadVenta < 0) {
			setMensaje(`la cantidad ingresada es incorrecta`)

		} else {
			const nuevoCarrito = carrito.map(item =>
				item.id === id ? { ...item, ...updatedItem } : item
			);
			setCarrito(nuevoCarrito);
			localStorage.setItem('carrito', JSON.stringify(nuevoCarrito));
			handleCloseEdit();
		}

		setTimeout(() => {
			setMensaje('')
		}, 6000);

	};

	// Manejar el cambio en el input
	const handleInputcantidad = (event) => {
		setCantidadVenta(event.target.value);
	};



	useEffect(() => {
		const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
		setCarrito(carritoGuardado)

		// Función para calcular el total
		const calcularTotal = (carrito) => {
			return carrito.reduce((total, item) => total + item.valorTotalPorProducto, 0);
		};

		// Llamada a la función para obtener el total
		const total = calcularTotal(carritoGuardado);
		setTotalNeto(total);
	}, [])

	// useEffect para recalcular el total cuando cambie el carrito
	useEffect(() => {
		const calcularTotal = (carrito) => {
			return carrito.reduce((total, item) => total + item.valorTotalPorProducto, 0);
		};

		// Actualiza el total cada vez que 'carrito' cambie
		const total = calcularTotal(carrito);
		setTotalNeto(total);

	}, [carrito]);


	// metodo para consultar la cc
	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			if (formDataPersona.cedula != '') {
				consultarCedula();
				setClienteVerificado(true);
			} else {
				setMensaje('El campo cedula es obligatorio')
			}
		}
	};

	// metodo para verificar el cliente antes de registrar la compra 
	const verificarCliente = () => {
		if (formDataPersona.cedula != '') {
			consultarCedula();
			setClienteVerificado(true);
		} else {
			setMensaje('El campo cedula es obligatorio')
		}

	}

	const consultarCedula = async () => {
		try {
			const res = await BuscarCliente(formDataPersona.cedula);
			if (res.success) {
				setFormDataPersona({
					cedula: res?.data?.cedula,
					nombre: res?.data?.nombre,
					apellido: res?.data?.apellido,
					direccion: res?.data?.direccion,
					celular: res?.data?.celular,

				})
				setCurrentPersona(res?.data);
				setIdCliente(res?.data?.Clientes[0]?.id);
				setCurrentCliente(res?.data?.Clientes);
				setMensaje('La persona ya existe con los siguientes datos personales ⬇️')
			} else {
				setIdCliente('')
				setMensaje(res.msg + ', Continuar con los datos ingrasados o ingrese los datos ');
				/*setFormDataPersona({
					cedula: formDataPersona.cedula,
					nombre: '',
					apellido: '',
					direccion: '',
					celular: '',

				})*/
			}

			setcontrol(res.success)
		} catch (error) {
			console.log(error)
		}
		setTimeout(() => {
			setMensaje('')
		}, 3000);

	};


	// Metodo para registrar una compra 
	const addCompra = async () => {
		if (formDataPersona.cedula === "" || formDataPersona.nombre === "" || formDataPersona.apellido === "") {
			setMensaje('Campos Obligatorios *')
		} else {
			setLoading(true);
			try {

				let estado = 0;
				let isAnyCheckedPendiente = false;
				let isventa = true;
				let tipo = "venta";
				let descripcion = "Abono inicial " + descripcionAbono;
				let total_financiado = financiado;

				// Verifica si hay al menos un checkbox marcado
				carrito.forEach((item) => {
					if (checkboxes[`isCheckedPendiente${item.id}`] || item?.pendientePorEntregar > 0) {
						isAnyCheckedPendiente = true;
					}
				});


				// esto es para validar el estado de la factura 
				if (checkboxes.isChecked) {
					estado = 1;
					total_financiado = (Number(totalNeto) + Number(transporte) - descuento) - montonFinanciado;
				} else if (isAnyCheckedPendiente) {
					estado = 2;
				} else {
					estado = 0;
				}


				// Verifico si la factura existe 
				if (checkboxes.isCheckedpago) {

					// actualizamos los pordustos 

					const res = await PostActualizarventa(currentFD);

					if (res?.success) {

						setCompraExitosa(true);
						// Ahora limpiamos el carrito.
						localStorage.removeItem('carrito');
						setLoading(false);
						const resF = await BuscarFactura(numeroFactura);

						const pendienteActules = resF?.data?.DetalleFacturas.some(
							item => item.pendientePorEntregar > 0
						);



						serIdfactura(resF.data.id);
						const nombreConductor = `${formDataFactura.nombre_conductor}`;


						const fechaActual = new Date().toISOString().split("T")[0];
						if ((Number(totalNeto) + Number(transporte) - descuento !== Number(totalAbonos)) && Number(total_financiado) > 0) {
							estado = 1;
						} else if (pendienteActules) {
							estado = 2;
						} else {
							estado = 0;
						}


						if (resF?.data?.tipo === 'venta') {

							await Editarfactura(
								resF?.data?.id,
								resF?.data.id_user,
								estado,
								subTotal,
								fechaPago,
								descuento,
								financiado,
								totalNeto,
								transporte,
								resF?.data?.tipo,
								formDataFactura.quien_recibe,
								formDataFactura.direccion_envio,
								nombreConductor,
								formDataFactura.celular_conductor

							);
						} else {
							await Editarfactura(
								resF?.data?.id,
								idUser,
								estado,
								subTotal,
								fechaPago,
								descuento,
								total_financiado,
								totalNeto,
								transporte,
								tipo,
								formDataFactura.quien_recibe,
								formDataFactura.direccion_envio,
								nombreConductor,
								formDataFactura.celular_conductor,
								fechaActual

							);

							if (checkboxes.isChecked) {
								await PostAbonoFactura(resF.data.id, montonFinanciado, descripcion, idUser);
							}
						}

					}
					setMensaje(res?.message);


				} else {

					// si la perosna no exite en la base de datos 
					if (!control || control == false) {
						const respersona = await PostPersona(formDataPersona);

						if (respersona.success) {
							const rescliente = await PostCliente(respersona.data.idP);
							if (rescliente.success) {
								const resf = await Postfactura(
									IDTransporte,
									idUser,
									rescliente.data.id,
									estado,
									totalNeto,
									fechaPago,
									descuento,
									total_financiado,
									totalNeto,
									transporte,
									tipo,
									formDataFactura.quien_recibe,
									formDataFactura.direccion_envio
								);

								serIdfactura(resf.data.id);
								if (resf?.success) {

									const resFD = await PostfacturaDetalle(isventa, resf.data.id, carrito);
									// en esta parte se agrega el abono solo si la factura es financiada 
									if (checkboxes.isChecked) {
										await PostAbonoFactura(resf.data.id, montonFinanciado, descripcion, idUser);
									}
									if (resFD?.success) {
										setCompraExitosa(true);
										// Ahora limpiamos el carrito.
										localStorage.removeItem('carrito');
										setLoading(false);
									} else {
										await EliminarFactura(resf.data.id);
										setMensaje('Fallo la compra, revise y vuelva a intentarlo');
										setLoading(false);
									}

								}
							}

						} else {
							setLoading(false);
						}
						setMensaje(respersona.msg);
					} else {

						// si la persona existe en la base de datos pero no es cliente 
						if (idCliente === undefined || currentCliente?.length === 0) {

							const rescliente = await PostCliente(currentPersona?.idP);


							if (rescliente.success) {
								const resf = await Postfactura(
									IDTransporte,
									idUser,
									rescliente.data.id,
									estado,
									totalNeto,
									fechaPago,
									descuento,
									total_financiado,
									totalNeto,
									transporte,
									tipo,
									formDataFactura.quien_recibe,
									formDataFactura.direccion_envio
								);

								serIdfactura(resf.data.id);
								if (resf?.success) {
									const resFD = await PostfacturaDetalle(isventa, resf.data.id, carrito);
									if (checkboxes.isChecked) {
										await PostAbonoFactura(resf.data.id, montonFinanciado, descripcion, idUser);
									}
									if (resFD?.success) {
										setCompraExitosa(true);
										// Ahora limpiamos el carrito.
										localStorage.removeItem('carrito');
										setLoading(false);
									} else {
										await EliminarFactura(resf.data.id);
										setMensaje('Fallo la compra, revise y vuelva a intentarlo');
										setLoading(false);
									}

								}

							}
						} else {
							// Si la perosona es cliente 
							if (idCliente !== '') {
								const resf = await Postfactura(
									IDTransporte,
									idUser,
									idCliente,
									estado,
									totalNeto,
									fechaPago,
									descuento,
									total_financiado,
									totalNeto,
									transporte,
									tipo,
									formDataFactura.quien_recibe,
									formDataFactura.direccion_envio
								);


								serIdfactura(resf.data.id);
								if (resf?.success) {
									const resFD = await PostfacturaDetalle(isventa, resf.data.id, carrito);

									if (checkboxes.isChecked) {
										await PostAbonoFactura(resf.data.id, montonFinanciado, descripcion, idUser);
									}
									if (resFD?.success) {
										setCompraExitosa(true);
										// Ahora limpiamos el carrito.
										localStorage.removeItem('carrito');
										setLoading(false);
									} else {
										await EliminarFactura(resf.data.id);
										setMensaje('Fallo la compra, revise y vuelva a intentarlo');
										setLoading(false);
									}
								}
							}

						}

					}

				}

			} catch (error) {
				console.log(error)
			}
		}



		setTimeout(() => {
			setMensaje('')
		}, 3000);
	}

	//Metodo para obtener los transportes disponibles en el sistema 
	const fetchTransporte = async (filters = {}) => {
		try {
			const res = await getTransporte(filters);
			setDatTransporte(res?.data);
		} catch (error) {
			console.error('Error al obtener los transportes:', error);
		}
	};

	useEffect(() => {
		fetchTransporte();
	}, []);

	//Metodo para seleccionar un transporte
	const obtenerdatosTransporte = (idSeleccionado) => {
		const transporteEncontrado = dataTransporte.find(
			(item) => item.id === idSeleccionado
		);

		if (!transporteEncontrado) return null;

		return {
			nombre: transporteEncontrado.Persona?.nombre,
			apellido: transporteEncontrado.Persona?.apellido,
			celular: transporteEncontrado.Persona?.celular,

		};
	};


	const fetchFactura = async () => {
		setLoading(true);
		try {

			const factura = await obtenerDetalleFactura(id);
			const detalles = factura?.data?.DetalleFacturas;
			const dataAbonos = factura?.data?.Abonos;
			setCurrentFactura(factura?.data);
			const cliente = factura?.data?.Cliente?.Persona;
			setCurrentPersona(cliente);
			setFormDataFactura({
				transporte: factura?.data?.transporte,
				nombre_conductor: factura?.data?.nombre_conductor,
				celular_conductor: factura?.data?.celular_conductor,
				quien_recibe: factura?.data?.quien_recibe,
				direccion_envio: factura?.data?.direccion,
			})


			setCheckboxes(prev => ({
				...prev,
				isCheckedpago: true
			}));

			//Metodo para sumar los subtotales de la venta 
			const subtotalSuma = detalles?.reduce((subtotal, item) => {
				return subtotal + Number(item.valorTotalPorProducto);
			}, 0);

			const abonosSuma = dataAbonos?.reduce((acc, item) => {
				return acc + Number(item.monto);
			}, 0);
			const descuentoFactura = Number(factura?.data?.descuento || 0);
			const transporteFactura = Number(factura?.data?.transporte || 0);
			const financiadoFactura = Number(factura?.data?.financiado || 0);



			//setPendientes(pendientes)
			setSubTotal(subtotalSuma);
			setTransporte(transporteFactura)
			setTotalNeto(subtotalSuma);
			setDescuento(descuentoFactura);
			setTotalAbono(abonosSuma);
			setNumeroFactura(factura?.data?.numeroFactura)
			setFinanciado(financiadoFactura);
			setFechaPago(factura?.data?.fechaDePago);

			if (descuentoFactura > 0) {
				setCheckboxes(prev => ({
					...prev,
					isCheckedDescuento: true
				}));
			}

			if (transporteFactura > 0) {
				setCheckboxes(prev => ({
					...prev,
					istransporte: true
				}));
			}



		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	}

	const fetchProductos = async () => {
		try {
			const factura = await obtenerDetalleFactura(id);
			const detalles = factura?.data?.DetalleFacturas || [];
			const productosBD = detalles.map((item) => ({
				id: item?.idProducto,
				idDetalle: item?.id,
				idProducto: item?.idProducto,
				bloque: item?.Producto?.Puesto?.Bloque?.name || "",
				puesto: item?.Producto?.Puesto?.numero || "",
				clase: item?.Producto?.Clase?.name || "",
				tipo: item?.Producto?.Tipo?.name || "",
				dimension: item?.Producto?.dimension || "",
				cantidad: Number(item?.pendientePorEntregar || 0),
				valorTotalPorProducto: Number(item?.valorTotalPorProducto || 0),
				cantidadTotal: Number(item?.Producto?.cantidad || 0),
				valorPorUnidad: Number(item?.valorPorUnidad || 0),
				pendientePorEntregar: Number(item?.pendientePorEntregar || 0),
				valordeventa: Number(item?.Producto?.precioVenta || 0),
			}));

			return productosBD;
		} catch (error) {
			console.log(error);
			return [];
		}
	};

	useEffect(() => {
		if (id) {
			// cargar factura existente
			fetchFactura();
		}
	}, [id]);

	const cargarDatos = async () => {
		if (!id) return;

		sessionStorage.removeItem(STORAGE_KEY);

		const productosBD = await fetchProductos();
		serCurrentProductos(productosBD)
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(productosBD));
	};

	useEffect(() => {
		cargarDatos();
	}, [id]);



	//Metodo para editar lo que viene de la bd
	const handleShowEditBD = (item) => {
		setCurrentProducto(item)
		setShowEdit(true);
		setShowEditBD(true);
		setCantidadVenta(item?.cantidad)
	};

	// metodo para editar del carrito de compra 
	const editarItemEntrega = (idDetalle) => {
		if (cantidadVenta > currentProducto?.cantidadTotal) {
			setMensaje(`Cantidad es mayor a la disponibles, disponible solo ${currentProducto?.cantidadTotal} unidades por favor consultar otro puesto`)

		} else if (cantidadVenta < 0) {
			setMensaje(`la cantidad ingresada es incorrecta`)

		} else if (currentProducto?.pendientePorEntregar < cantidadVenta) {
			setMensaje(`la cantidad ingresada es mayor a la cantidad pendiente por entrega revisar`)
		} else {
			const productosActualizados = currentProductos.map((item) =>
				item.idDetalle === idDetalle
					? { ...item, cantidad: Number(cantidadVenta) }
					: item
			);

			serCurrentProductos(productosActualizados);
			sessionStorage.setItem(STORAGE_KEY, JSON.stringify(productosActualizados));
			handleCloseEdit();
		}

		setTimeout(() => {
			setMensaje('')
		}, 6000);

	};


	// Metodos para el popup de eliminar los productos de la base de datos 
	const handleShowEliminarBD = (item) => {
		setShowEliminar(true);
		setShowEliminarBD(true);
		setCurrentProducto(item);

	};


	// metodo para eliminar del carrito de compra
	const eliminarItemBD = async () => {

		try {
			const resVD = await deleteDetalleVenta(currentProducto.id);
			if (resVD?.success) {
				await fetchFactura();
				await cargarDatos();
				setAlert(true)
				setMensaje(resVD.message)
				handleCloseEliminar();
			}

		} catch (error) {
			console.log(error);
		}

		setTimeout(() => {
			setAlert(false)
			setMensaje("")
		}, 3000)

	};

	const getEstadoProducto = (item) => {
		if (item?.pendientePorEntregar === 0 && currentFactura?.tipo === 'venta') {
			return {
				texto: "Entregado",
				clase: "bg-success text-white"
			};
		}

		if (item?.pendientePorEntregar > item?.cantidadTotal) {
			return {
				texto: `Agotados`,
				clase: "bg-danger text-white"
			};
		}

		return {
			texto: "Disponibles",
			clase: "bg-warning text-white"
		};
	};


	const generarPdf = async () => {
		await abrirPdfVentas(id ?? idfactura);
		navigate('/factura');
	};

	return (
		<Fragment>
			<div className='d-flex justify-content-center'>
				<AlertComponent styleGroup="bg-soccess color-white" mensaje={mensaje} activaalert={alert} />
			</div>
			<HeaderComponent styleGroup="">
				<TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">CARRITO</TitleH2Component>
				{(currentFactura?.tipo === "cotizacion" ||
					(currentFactura?.tipo === "venta" && currentFactura?.estado != 0) ||
					(currentFactura?.estado === 0 && isSuper)) && (
						<Link
							to={`/editar-factura-venta/${currentFactura?.id}`}
							className={`${stylebtn.btn} ${stylebtn.primary} ${isAdmin || (!isAdmin && currentFactura?.tipo !== "venta")
								? ""
								: "d-none"
								}`}
						>
							EDITAR VENTA
						</Link>
					)}
			</HeaderComponent>
			{carrito.length !== 0 || currentProductos.length !== 0 ? (
				<div className="conatiner-global pt-3 pb-5">
					<div className="container mt-3">
						<div className="row gy-5">
							<div className="col-xl-9 col-12">
								<div className="table-responsive ">
									<table className="table table-bordered tableGeneral">
										<thead>
											<tr>
												<th scope="col">Pend. Entrega</th>
												<th>UBICACION</th>

												<th scope="col" colspan="2">
													Descripción
												</th>
												<th scope="col">Cant.</th>
												<th>Precio</th>
												<th>Subtotal</th>
												<th>Estado</th>
												<th scope="col"></th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody>
											{currentProductos.map((item, index) => {

												return (
													<tr key={index}>
														<th>
															{item?.pendientePorEntregar}
														</th>

														<th>B{item.bloque}/P{item.puesto}</th>

														<td colspan="2">{item.tipo} de {item.clase} {item.dimension}</td>
														<td>{item.cantidad}</td>
														<th>${Number(item?.valorPorUnidad).toLocaleString('es-ES')}</th>
														<th>${Number(item?.valorTotalPorProducto).toLocaleString('es-ES')}</th>
														<td className={getEstadoProducto(item).clase}>
															{getEstadoProducto(item).texto}
														</td>
														<td>
															<button
																className={`${styleBtn.btn_desnudo} ${styleBtn.icon} ms-3 p-0 d-inline-flex`}
																onClick={() => handleShowEditBD(item)}
															>
																<Icon icon="raphael:edit" />
															</button>
														</td>
														<td>
															<button
																className={`${styleBtn.btn_desnudo} ${styleBtn.icon} ms-3 p-0 d-inline-flex color-danger`}
																onClick={() => handleShowEliminarBD(item)}
															>

																<Icon icon="majesticons:delete-bin" />
															</button>
														</td>
													</tr>
												)
											})}

											{carrito.map((item, index) => {

												return (
													<tr key={index}>
														<th>
															<div className={`${styleform.checkbox} d-flex justify-content-center mb-2`}>
																<input
																	className="me-2"
																	type="checkbox"
																	value=""
																	id={`isCheckedPendiente${item.id}`}
																	checked={checkboxes[`isCheckedPendiente${item.id}`] !== undefined
																		? checkboxes[`isCheckedPendiente${item.id}`]
																		: item?.pendientePorEntregar > 0}
																	onChange={handleCheckboxChange}
																/>
															</div>
															{(checkboxes[`isCheckedPendiente${item.id}`] || item?.pendientePorEntregar > 0) && (
																<Fragment>

																	<input
																		className="input-small"
																		placeholder="Cantidad: "
																		styleLabel="fw600 WorkSans"
																		styleGroup=" mb-2"
																		htmlFor="bloque"
																		type="number"
																		value={pendientePorentraga[item.id] !== undefined ? pendientePorentraga[item.id] : item?.pendientePorEntregar || ''}
																		onChange={(e) => handleInputChangependienteporentrega(e, item.id)}
																	//onKeyDown={(e) => handleKeyDownobtnerpendiente(e, item)}
																	/>
																	<button type='button' className={`${stylebtn.btn} ${stylebtn.primary}  mt-1`} onClick={() => obtnerpendiente(item)}>OK</button>
																</Fragment>

															)}

														</th>

														<th>B{item.bloque}/P{item.puesto}</th>
														<td colspan="2">{item.tipo} de {item.clase} {item.dimension}</td>
														<td>{item.cantidad}</td>
														<th>${Number(item?.valorPorUnidad).toLocaleString('es-ES')}</th>
														<th>${Number(item?.valorTotalPorProducto).toLocaleString('es-ES')}</th>
														<td className={getEstadoProducto(item).clase}>
															{getEstadoProducto(item).texto}
														</td>
														<td>
															<button
																className={`${styleBtn.btn_desnudo} ${styleBtn.icon} ms-3 p-0 d-inline-flex`}
																onClick={() => handleShowEdit(item)}
															>
																<Icon icon="raphael:edit" />
															</button>
														</td>
														<td>
															<button
																className={`${styleBtn.btn_desnudo} ${styleBtn.icon} ms-3 p-0 d-inline-flex color-danger`}
																onClick={() => handleShowEliminar(item)}
															>

																<Icon icon="majesticons:delete-bin" />
															</button>
														</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
							</div>
							<div className="col-xl-3 col-12">
								<div className="d-flex flex-column justify-content-center align-items-center">
									<TitleH4Component styleGroup=" color-dark text-center fw700 roboto">
										RESUMEN DE LA COMPRA
									</TitleH4Component>
									<ParrafoComponent styleGroup=" color-dark fw400 WorkSans ">- Precio neto: ${Number(totalNeto).toLocaleString('es-ES')}</ParrafoComponent>
									<ParrafoComponent styleGroup=" color-dark fw400 WorkSans ">- Descuento: ${Number(checkboxes.isCheckedDescuento ? descuento : 0).toLocaleString('es-ES')}</ParrafoComponent>
									<ParrafoComponent styleGroup=" color-dark fw400 WorkSans ">- Transporte: ${Number(checkboxes.istransporte ? transporte : 0).toLocaleString('es-ES')}</ParrafoComponent>
									<ParrafoComponent styleGroup="color-dark fw400 WorkSans">
										- Total: ${Number(
											checkboxes.isCheckedDescuento
												? checkboxes.istransporte
													? (Number(totalNeto) + Number(transporte)) - Number(descuento)
													: totalNeto - descuento
												: checkboxes.istransporte
													? Number(totalNeto) + Number(transporte)
													: totalNeto
										).toLocaleString('es-ES')}
									</ParrafoComponent>
									<div className={`${styleform.checkbox} d-flex justify-content-center mb-2`}>
										<input
											className=" me-2"
											type="checkbox"
											value=""
											id="isChecked"
											checked={checkboxes.isChecked}
											onChange={handleCheckboxChange}
										/>
										<label className="color-dark  fw700" htmlFor="recorddat">
											Financiado
										</label>
									</div>
									{checkboxes.isChecked && (
										<Fragment>
											<div>
												<MoneyInputComponent
													label="Abono Inicial"
													placeholder="Cantidad a financiar"
													styleLabel="fw600 WorkSans"
													styleGroup=" mb-2"
													htmlFor="bloque"
													type="number"
													name='montonfinanciado'
													value={montonFinanciado}
													onChange={handleInputChangemontonfinanciado}
												/>
												<InputComponent
													label="Fecha de pago*"
													placeholder="Cantidad a financiar"
													styleLabel="fw600 WorkSans"
													styleGroup=" mb-2"
													htmlFor="bloque"
													type="date"
													name='fechapago'
													value={fechaPago}
													onChange={handleInputChangefechapago}
												/>

												<textarea
													label="descripcion"
													name="descripcionAbono"
													placeholder="Descripción"
													className="form-control mb-2"
													rows={3}
													value={descripcionAbono}
													onChange={handleChangeDescripcion}

												></textarea>
											</div>

										</Fragment>
									)}
									<div className={`${styleform.checkbox} d-flex justify-content-center mb-2`}>
										<input
											className=" me-2"
											type="checkbox"
											value=""
											id="isCheckedDescuento"
											checked={checkboxes.isCheckedDescuento}
											onChange={handleCheckboxChange}
										/>
										<label className="color-dark  fw700" htmlFor="recorddat">
											Descuento
										</label>
									</div>
									{checkboxes.isCheckedDescuento && (
										<MoneyInputComponent
											placeholder="Ingrese Descuento"
											styleLabel="fw600 WorkSans"
											styleGroup="mb-2"
											htmlFor="descuento"
											type="number"
											name='descuento'
											value={descuento}
											onChange={handleInputChangedescuento}
										/>
									)}

									<div className={`${styleform.checkbox} d-flex justify-content-center mb-2`}>
										<input
											className=" me-2"
											type="checkbox"
											value=""
											id="istransporte"
											checked={checkboxes.istransporte}
											onChange={handleCheckboxChange}
										/>
										<label className="color-dark  fw700" htmlFor="recorddat">
											Transporte
										</label>
									</div>
									{checkboxes.istransporte && (
										<div>
											<MoneyInputComponent
												label='Costo'
												placeholder="Ingrese transporte"
												styleLabel="fw600 WorkSans"
												styleGroup=" mb-2"
												htmlFor="transporte"
												type="number"
												name='transporte'
												value={transporte}
												onChange={handleInputChangetransporte}
											/>

											<SelectComponent
												label="Transporte"
												styleGroup={`${stylegenral.wselect}`}
												styleLabel="fw600 WorkSans color-madera"
												options={dataTransporte.map((transporte) => ({
													value: transporte.id,
													label: transporte?.Persona?.nombre + ' ' + transporte?.Persona?.apellido
												}
												))}

												capOpcions={(v) => {
													setTransporteID(v);
													setIDTransporte(v);
													const datos = obtenerdatosTransporte(v);

													if (datos) {
														setFormDataFactura({
															nombre_conductor: `${datos?.nombre} ${datos.apellido}`,
															celular_conductor: datos.celular
														})
													}
												}}
												customPlaceholder="Seleccionar"

												name="transporte"
												value={dataTransporte.find(o => o.value == transporteID) || null}

												isClearable
											/>
											{formDataFactura.nombre_conductor && <ParrafoComponent styleGroup=" color-madera fw400 WorkSans my-2">
												Nombre: {formDataFactura.nombre_conductor}
											</ParrafoComponent>}
											{formDataFactura?.celular_conductor && <ParrafoComponent styleGroup=" color-madera fw400 WorkSans mb-2">
												Celular: {formDataFactura?.celular_conductor}
											</ParrafoComponent>}
										</div>



									)}


									{id && <div className={`${styleform.checkbox} d-flex justify-content-center my-2`}>
										<input
											className=" me-2"
											type="checkbox"
											value=""
											id="isCheckedpago"
											checked={checkboxes.isCheckedpago}
											onChange={handleCheckboxChange}
											disabled
										/>
										<label className="color-dark  fw700" htmlFor="recorddat">
											Fact. Existente
										</label>
									</div>}

									{checkboxes.isCheckedpago && (
										<InputComponent
											placeholder="Ingrese Num. de factura"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-2"
											htmlFor="bloque"
											type="text"
											name='numeroFactura'
											value={numeroFactura}
											disabled
											onChange={handleInputChangeNumeroFactura}

										/>
									)}

									<ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans mb-2">{mensaje}</ParrafoComponent>

									<button
										type="button"
										className={`${stylebtn.btn} ${stylebtn.primary}  mt-1`}
										onClick={handleShowcliente}
									>
										Continuar compra
									</button>

								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<TitleH2Component styleGroup="box-text color-dark fw700 roboto mt-5 text-center WorkSans">
					CARRITO DE COMPRAS VACIO
				</TitleH2Component>
			)}




			{/** modal eliminar un producto del carrito **/}
			<section>
				<ModalGeneralComponent
					styleGroup="d-flex align-items-center modal-general "
					styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
					show={showEliminar}
					handleClose={handleCloseEliminar}
				>
					<form action="">
						<TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar este producto ${showEliminarBD ? currentProducto?.tipo : currentCarrito?.tipo} ${showEliminarBD ? currentProducto?.clase : currentCarrito?.clase} ?`}</TitleH2Component>

						<div className="d-flex justify-content-end">
							<button type="button" onClick={handleCloseEliminar} className={`btn ${stylebtn.btn} ${stylebtn.danger} `}>
								Cancelar
							</button>
							<button type="button" onClick={showEliminarBD ? eliminarItemBD : eliminarItem} className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}>
								SI
							</button>
						</div>
					</form>
				</ModalGeneralComponent>
			</section>

			{/** modal editar cantidad el en carrito de compra**/}
			<section>
				<ModalGeneralComponent
					ModalHeader
					titulo="EDITAR CANTIDAD A ENTRAGAR"
					styleGroup="d-flex align-items-center modal-general "
					styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
					show={showEdit}
					handleClose={handleCloseEdit}
				>
					<form action="">
						<ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">{mensaje}</ParrafoComponent>
						<InputComponent
							placeholder="Ingrese"
							label="CANTIDAD PRODUCTO:"
							styleLabel="fw600 WorkSans"
							styleGroup=" mb-2"
							htmlFor="bloque"
							type="number"
							name='cantidad'
							value={cantidadVenta}
							onChange={handleInputcantidad}
						/>
						<ParrafoComponent styleGroup=" color-dark fw400 WorkSans">{`Disponible: ${showEditBD ? currentProducto?.cantidadTotal : currentCarrito?.cantidadTotal} Unidad`}</ParrafoComponent>

						<div className="d-flex justify-content-end">
							<button type="button" onClick={handleCloseEdit} className={`btn ${stylebtn.btn} ${stylebtn.danger} `}>
								Cancelar
							</button>
							{showEditBD ? <button type="button" onClick={() => editarItemEntrega(currentProducto?.idDetalle)} className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}>
								OK
							</button> :
								<button type="button" onClick={() => editarItem(currentCarrito?.id, { cantidad: cantidadVenta, valorTotalPorProducto: currentCarrito?.valorPorUnidad * cantidadVenta })} className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}>
									OK
								</button>}
						</div>
					</form>
				</ModalGeneralComponent>
			</section>

			{/** modal ingresar informacion del cliente **/}
			<section>
				<ModalGeneralComponent
					ModalHeader={compraExitosa ? false : true}
					titulo="Información del cliente"
					styleGroup={`d-flex align-items-center modal-general `}
					styleBody={`${compraExitosa ? 'bg-gris-modal ' : ''}`}
					styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
					show={showCliente}
					handleClose={handleClosecliente}
				>
					{loading ? (<LoaderComponent styleGroup="mt-5" />) : !compraExitosa ? (
						<form action="">
							<ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">{mensaje}</ParrafoComponent>
							<div className="container">
								<div className="row">
									<div className="col-12">

										<label htmlFor={'cedula'} className={`fw600 WorkSans color-madera`}>
											Cedula*
										</label>
										<input
											type="text"
											htmlFor="cudula"
											className='form-control fw600 WorkSans mb-4'
											placeholder='Ingrese la cc'
											name='cedula'
											value={formDataPersona.cedula}
											onChange={handleInputChangePersona}
											onKeyDown={handleKeyDown} required />


									</div>
									<div className="col-12 col-sm-6">
										<InputComponent
											placeholder="Ingrese"
											label="Nombres*:"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-4"
											htmlFor="nombre"
											type="text"
											value={formDataPersona.nombre}
											name="nombre"
											onChange={handleInputChangePersona}
										/>
									</div>
									<div className="col-12 col-sm-6">
										<InputComponent
											placeholder="Ingrese"
											label="Apellidos*:"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-4"
											htmlFor="apellido"
											type="text"
											value={formDataPersona.apellido}
											name="apellido"
											onChange={handleInputChangePersona}
										/>
									</div>
									<div className="col-12 col-sm-6">
										<InputComponent
											placeholder="Ingrese"
											label="Direccion:"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-4"
											htmlFor="direccion"
											type="text"
											value={formDataPersona.direccion}
											name="direccion"
											onChange={handleInputChangePersona}
										/>
									</div>
									<div className="col-12 col-sm-6">
										<InputComponent
											placeholder="Ingrese"
											label="Celular:"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-4"
											htmlFor="celular"
											type="text"
											value={formDataPersona.celular}
											name="celular"
											onChange={handleInputChangePersona}
										/>
									</div>

								</div>
								<ParrafoComponent styleGroup="color-madera fw700 WorkSans">DATOS DE LA FACTURA</ParrafoComponent>
								<div className="row">
									<div className="col-12 col-sm-6">
										<InputComponent
											placeholder="Ingrese"
											label="Quien recibe:"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-4"
											htmlFor="quien_recibe"
											type="text"
											value={formDataFactura.quien_recibe}
											name="quien_recibe"
											onChange={handleInputChangeFactura}
										/>
									</div>

									<div className="col-12 col-sm-6">
										<InputComponent
											placeholder="Ingrese"
											label="Direccion de envio:"
											styleLabel="fw600 WorkSans"
											styleGroup=" mb-4"
											htmlFor="direccion_envio"
											type="text"
											value={formDataFactura.direccion_envio}
											name="direccion_envio"
											onChange={handleInputChangeFactura}
										/>
									</div>
								</div>

							</div>

							<div className="d-flex justify-content-end">
								<button
									type="button"
									onClick={handleClosecliente}
									className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
								>
									Cancelar
								</button>
								{clienteVerificado ? <button type="button" className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`} onClick={addCompra}>
									Continuar
								</button> :
									<button type="button" className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`} onClick={verificarCliente}>
										Verificar cliente
									</button>}
							</div>
						</form>
					) : (
						<div>
							<div className="d-flex justify-content-end mb-0 align-items-center mb-3">
								<button
									type='button'
									onClick={generarPdf}
									className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}>
									Generar factura
								</button>
								<button
									type="button"
									className={`btn ${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
									onClick={handleClosecliente}
								>
									<Icon icon="mdi:close-thick" />
								</button>
							</div>
							<TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
								¡¡Compra realizada con éxito!!
							</TitleH2Component>
						</div>
					)}
				</ModalGeneralComponent>
			</section>

			{/** modal para agragar pendientes al carrito de compras **/}
			<section>
				<ModalGeneralComponent
					styleGroup="d-flex align-items-center modal-general "
					styleTitle={'box-text color-madera fw700 roboto text-center WorkSans'}
					show={showaddpendientes}
					handleClose={handleCloseaddpendientes}
				>
					<form action="">
						<ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">{mensaje}</ParrafoComponent>

						<TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere agregar ${pendientevalor} unidades pendientes al producto ${currentCarrito?.tipo} de ${currentCarrito?.clase} ?`}</TitleH2Component>

						<div className="d-flex justify-content-end">
							<button type="button" onClick={handleCloseaddpendientes} className={`btn ${stylebtn.btn} ${stylebtn.danger} `}>
								Cancelar
							</button>
							<button type="button" onClick={() => addPendientes(currentCarrito?.id, { pendientePorEntregar: pendientevalor, valorTotalPorProducto: (currentCarrito?.valorPorUnidad * currentCarrito?.cantidad) + (currentCarrito?.valorPorUnidad * pendientevalor) })} className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}>
								SI
							</button>
						</div>
					</form>
				</ModalGeneralComponent>
			</section>
		</Fragment>
	);
};

export default CarritoPage;
